import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface SearchBjhTopicListParams extends ActiomCommonParams {
    token: string;
    topicContent: string;
}

export interface TopicData {
    title: string;
    id: string;
}

export type PublishAction = CommonAction<SearchBjhTopicListParams, TopicData[]>;

export const searchBjhTopicList: PublishAction = async (_task, params) => {
    const cookies = params.cookies ?? [];

    const http = new Http({
        headers: {
            cookie: cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            token: params.token,
        },
    });

    const res = await http.api<{ errno: number; data: { hot: TopicData[] } }>({
        method: "get",
        url: "https://baijiahao.baidu.com/pcui/pcpublisher/searchtopic",
        params: {
            content: params.topicContent,
            resource_type: 1,
        },
    });

    return success(res?.data?.hot ?? [], `百家号${res.errno === 0 ? "话题获取成功！" : "话题获取失败"}`);
};
